window.addEventListener('load', (event) => {
  const quantityInputs = document.querySelectorAll('[data-input="quantity"]');
  if (!quantityInputs.length) return;
  quantityInputs.forEach(initProductQuantityInput);
});

function initProductQuantityInput(quantityInput) {
  const productForm = document.querySelector(`form[data-product_form='${quantityInput.dataset.product_id}']`);
  const productQuantity = productForm.querySelector("input[name='quantity']");
  initQuantityInput(quantityInput, function (input, value) {
    productQuantity.value = value;
  });
}
